// extracted by mini-css-extract-plugin
export default {"container":"Body_container__4Nlk7","heading":"Body_heading__+1eTr","toolbar":"Body_toolbar__K26Wz","colors":"Body_colors__dhYH7","color":"Body_color__Wqq89"};